module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Robyn Bennis\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("ROBYN BENNIS works in biotech but dreams of airships. She lives in Mountain View, CA, within sight of the historic Hangar One at Moffett Federal Airfield. "), _c('I', [_vm._v("The Guns Above")]), _vm._v(" is her debut novel.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/MJtY7z/tc-custom/9780765388773.jpg?1718183454722",
      "alt": "This image is the cover for the book Guns Above, The Signal Airship Novels"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Guns Above, The Signal Airship Novels\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("Robyn Bennis’s THE GUNS ABOVE is an adventurous military fantasy debut about a nation's first female airship captain.")]), _c('br'), _c('b', [_c('br'), _vm._v("They say it’s not the fall that kills you. "), _c('br')]), _c('br'), _vm._v("For Josette Dupre, the Corps’ first female airship captain, it might just be a bullet in the back. "), _c('br'), _c('br'), _vm._v("On top of patrolling the front lines, she must also contend with a crew who doubts her expertise, a new airship that is an untested deathtrap, and the foppish aristocrat Lord Bernat, a gambler and shameless flirt with the military know-how of a thimble. Bernat’s own secret assignment is to catalog her every moment of weakness and indecision. "), _c('br'), _c('br'), _vm._v("So when the enemy makes an unprecedented move that could turn the tide of the war, can Josette deal with Bernat, rally her crew, and survive long enough to prove herself?"), _c('br'), _c('br'), _vm._v("“Full of sass and terrific characters. Great storytelling.  Loved it.” —Patricia Briggs"), _c('br'), _c('br'), _vm._v("At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Tom Doherty Associates\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0